import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CatalogItem } from '../../../models/catalog/catalogItem';
import { CatalogService } from '../../../models/catalog/catalogService';
import { FormMode } from '../../../core/constants';
import { CatalogItemComponent } from '../catalog-item/catalog-item.component';

@Component({
  selector: 'app-edit-catalog-item',
  standalone: false,
  templateUrl: './edit-catalog-item.component.html',
})
export class EditCatalogItemComponent {
  // @Input() item: Partial<CatalogItem> = CatalogItem.createEmpty();
  @Input() itemId: string = '';
  @Input() catalogId: string = '';
  @Input() isNew: boolean = false;

  @Output() saved = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @ViewChild('item') catalogItemRef!: CatalogItemComponent

  FormMode = FormMode;
  _item: Partial<CatalogItem> = CatalogItem.createEmpty();

  constructor(private catalogService: CatalogService) {}

  ngOnInit(): void {
    if (this.itemId) {
      this._updateItemFromSystem();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itemId']) {
      this.itemId = changes['itemId'].currentValue;
      this._updateItemFromSystem();
    }
  }

  private _updateItemFromSystem() {
    if (this.itemId && this.itemId != '') {
      this.catalogService.getCatalogItem(this.itemId).then((item) => {
        this._item = item;
      });
    }
  }

  btnSave_click() {
    const item = this.catalogItemRef._data
    if (this.itemId) {
      console.log('saveCatalogItem', item);
      this.catalogService.saveCatalogItem(item).then(() => {
        this.saved.emit();
      });
    } else {
      item.catalogId = this.catalogId;
      item.currencyCode = 'USD';
      console.log('createCatalogItem', item);
      this.catalogService.createCatalogItem(item).then(() => {
        this.saved.emit();
      });
    }
  }

  btnCancel_click() {
    this.cancelled.emit();
  }
}
